<template>
    <div class="bg-indigo-50 p-5 rounded">
        <div class="font-bold">Устройства</div>
        <div class="mt-2">
            <div class="sm:flex">
                <div v-for="item in devices" :key="item.id" @click="toggleDevice(item)">
                    <div :class="[item.checked ? 'border-transparent' : 'border-gray-300', item.active ? 'border-indigo-500 ring-2 ring-indigo-500' : '', 'relative bg-white border rounded-lg shadow-sm p-2 flex cursor-pointer focus:outline-none mt-2 sm:mt-0 sm:mr-2']">
                        <div class="flex-1 flex">
                            <div class="flex">
                                <div class="flex-shrink-0">
                                    <component :is="item.icon" class="'text-gray-400 group-hover:text-gray-500 mr-4 flex-shrink-0 h-6 w-6" aria-hidden="true" />
                                </div>
                                <div class="block text-gray-900">
                                    {{ item.title }}
                                </div>
                            </div>
                        </div>
                        <div :class="[item.active ? 'border' : 'border-2', item.checked ? 'border-indigo-500' : 'border-transparent', 'absolute -inset-px rounded-lg pointer-events-none']" aria-hidden="true" />

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import rules_dictionary from "@/scripts/store/rules_dictionary";

export default {

    props: {
        modelValue: {
            required: true
        }
    },

    mounted() {
        this.devices.forEach(device => device.checked = false)

        if (!this.modelValue.devices || this.modelValue.devices.length <= 0) {
            return
        }

        this.modelValue.devices.forEach(deviceId => {
            this.devices.find(d => d.id === deviceId).checked = true
        })
    },

    data() {
        return {
            devices: rules_dictionary.devices
        }
    },

    methods: {
        toggleDevice(device) {
            device.checked = !device.checked

            const selectedDevices = this.devices
                .filter(device => device.checked)
                .map(device => device.id)

            if (selectedDevices.length > 0) {
                this.$emit('update:modelValue', {devices: selectedDevices})
            } else {
                this.$emit('update:modelValue', {})
            }
        }
    }
}
</script>
